<template>
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      
        <div class="row">
          <div class="col-4">
            <p class="label">Role</p>
            <tl-select
              :name="'role'"
              :options="roleList"
              v-model="formData.role"
              @change="(val) => formData.role = val"
              placeholder="Search Role"
            />
          </div>
          <div class="col-4">
            <p class="label" v-if="this.formData.role">Search Screen</p>
            <tl-select
            v-if="this.formData.role"
            :options="permissionoption"
            v-model="screenpermission"
            @change="(val)=>screenpermission=val"
              placeholder="Search Screen"
            />
          </div>
          <div class="col-4 addTagBtn" v-if="screenpermission">
            <btn type="secondary" text="Add Permission" @click="addTags()"></btn>
          </div>
        </div>
        <div class="row">
          <div class="col-4"></div>
        <div class="col-8" v-if="tagsArray.length>0">
          <div class="selectedComp">
            <div v-for="(data, index) in tagsArray" :key="index">
              <div class="rect">
                <button>
                  <span class="tag-title">{{ data.name }}</span>
                  <img src="@/assets/close_cross_circle.svg" @click="removeTag(data.key)" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
          <div class="col-4">
            <p class="label">Organisation</p>
            <tl-select
              :name="'organisation'"
              :options="organisationList"
              v-model="orgName"
              @change="(val) => getLeData(val)"
              placeholder="Search Organisation"
            />
          </div>
           <div class="col-8 addTagBtn" v-if="orgName">
            <btn type="secondary" text="Add Organisation" @click="addOrgTags()"></btn>
          </div>
      </div> 

      <div class="row">
        <div class="col-12" v-if="tagsOrgsArray.length>0">          
          <div>
            <div v-for="(data, index) in tagsOrgsArray" :key="index">
              <div class="row mt-5">
                <div class="col-4">
                  <div class="rect">
                    <button>
                      <span class="tag-title">{{ data.name }}</span>
                      <img src="@/assets/close_cross_circle.svg" @click="removeOrgTags(data.id)" />
                    </button>
                  </div>
                </div>
                <div class="col-4">
                  <p class="labelText" v-if="data.name">Legal Entity</p>
                  <tl-select
                    v-if="data.name"
                    :options="data.entityList"
                    v-model="data.entity"
                    @change="(val)=>data.entity=val"
                    placeholder="Search Legal Entity"
                  />
                </div>
                <div class="col-3 legalBtn">
                  <btn type="secondary" v-if="data.entity" text="Add Legal Entity" @click="addEntityTags(data)"></btn>
                </div>
                <div class="col-4"></div>
                <div class="col-8" v-if="data.tagsEntityArray.length > 0">
                  <div class="mt-3">
                    <div v-for="(entity, entityIndex) in data.tagsEntityArray" :key="entityIndex">
                      <div class="row mt-3">
                        <div class="col-4">
                          <div class="input-label">From Date</div>
                          <date-picker
                            class="ht-35 margin-top-5"
                            @datevalue="(val)=>dateChanged(data, entityIndex, val, 'From Date')"
                            :value="entity.from_date"
                            v-model="entity.from_date"
                            :formatDate="'yyyy-MM-dd'"
                            :disabled="false"
                          />
                        </div>
                        <div class="col-4">
                          <div class="input-label">To Date</div>
                          <date-picker
                            class="ht-35 margin-top-5"
                            @datevalue="(val)=>dateChanged(data, entityIndex, val, 'To Date')"
                            :value="entity.to_date"
                            v-model="entity.to_date"
                            :formatDate="'yyyy-MM-dd'"
                            :disabled="false"
                          />
                        </div>
                        <div class="col-4">
                          <div class="rect">
                            <button>
                              <span class="tag-title">{{ entity.name }}</span>
                              <img src="@/assets/close_cross_circle.svg" @click="removeEntityTags(data, entityIndex)" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-3">
            </div>
              
              <!-- <div class="row">
                <div class="col-10">
                  
                
              </div>
              <div class="row">
                <div class="col-12" v-if="data.tagsEntityArray.length > 0">
                  <div class="selectedComp">
                    <div v-for="(data,index) in data.tagsEntityArray" :key="index">
                      <div class="rect">
                        <button>
                          <span class="tag-title">{{ data.name }}</span>
                          <img src="@/assets/close_cross_circle.svg" @click="removeEntityTags(data.key)" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div> -->
          </div>
        </div>
      </div>   
      
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Employee's Permissions Updated Successfully.`"
        btnText="OK"
        @back="gotoSignIn()"
      ></pop-up-message>
      <footer>
        <popup-bottom-container class="position-fixed marginleft">
            <btn-grp slot="end">
              <btn text="Cancel" type="secondary" @click="backToWelcomeScreen" />
              <btn text="Save" type="primary" @click="performAction"></btn>
            </btn-grp>
        </popup-bottom-container>
      </footer>
    </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    userRole: {
      type: Object
    }
  },
  data() {
    return {
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      formData: {
        user_id: "",
        role: "",
        permissions: {},
        organisations: {},
      },
      roleList: ['ADMIN', 'TEAMLEADER', 'ANCHOR', 'AUDITOR', 'CLIENTADMIN'],
      permissiontype: "",
      screenpermission: "",
      permissionList: [
        {
          key: "all_permission",
          name: "All Permission",
        },
        ,{
          key: "add_user",
          name: "Add User",
        },
        {
          key: "add_user_permission",
          name: "Add User Permission",
        },
        {
          key: "create_legal_entity",
          name: "Create Legal Entity",
        },
        {
          key: "create_organisation",
          name: "Create Organisation",
        },
        {
          key: "organisation_list",
          name: "Organisation List",
        },
        {
          key: "legal_entity_list",
          name: "Legal Entity List",
        },
        {
          key: "legal_entity_info",
          name: "Legal Entity Info",
        },
        {
          key: "location",
          name: "Location",
        },
        {
          key: "statutory_settings",
          name: "Statutory Settings",
        },
        {
          key: "departments",
          name: "Departments",
        },
        {
          key: "cost_centers",
          name: "Cost Centers",
        },
        {
          key: "designation",
          name: "Designation",
        },
        {
          key: "levels",
          name: "Levels",
        },
        {
          key: "salary_grade",
          name: "Salary Grade",
        },
        {
          key: "emp_cat_and_sub_cat",
          name: "Emp Cat and Sub-Cat",
        },
        {
          key: "salary_bands",
          name: "Salary Bands",
        },
        {
          key: "misc",
          name: "Misc",
        },
        {
          key: "payroll_preferences",
          name: "Payroll Preferences",
        },
        {
          key: "paygroup",
          name: "Paygroup",
        },
        {
          key: "add_employee",
          name: "Add Employee",
        },
        {
          key: "legacy_data",
          name: "Legacy Data",
        },
        {
          key: "payroll_dashboards",
          name: "Payroll Dashboards",
        },
        {
          key: "it_declarations",
          name: "IT Declarations",
        },
        {
          key: "it_proof_submission",
          name: "IT Proof Submission",
        },
        {
          key: "it_proof_approval",
          name: "IT Proof Approval",
        },
        {
          key: "assign_fixed_non_ctc_component",
          name: "Assign fixed & Non CTC component",
        },
        {
          key: "exit_employee_details",
          name: "Exit employee Details",
        },
        {
          key: "delete_payroll_data",
          name: "Delete payroll data",
        },
        {
          key: "form_16",
          name: "Form 16",
        },
        {
          key: "hold_release_salary",
          name: "Hold/Release salary",
        },
        {
          key: "increment_arrear_override",
          name: "Increment Arrear Override",
        },
        {
          key: "leaves_attendance",
          name: "Leaves Attendance",
        },
        {
          key: "legacy_salary",
          name: "Legacy salary",
        },
        {
          key: "lop_rlop",
          name: "Lop/Rlop",
        },
        {
          key: "revise_salary",
          name: "Revise salary",
        },
        {
          key: "statutory_bonus",
          name: "Statutory Bonus",
        },
        {
          key: "statutory_deduction",
          name: "Statutory Deduction",
        },
        {
          key: "manage_roles",
          name: "Manage Roles",
        },
        {
          key: "download_upload_master_template",
          name: "Download/Upload Master Template",
        },
        {
          key: "ess_management",
          name: "ESS Management",
        },
        {
          key: "payslips_it_sheets",
          name: "Payslips & IT Sheets",
        },
        {
          key: "update_form_24q_acknowledgement",
          name: "Update Form 24Q acknowledgement",
        },
        {
          key: "company",
          name: "Company",
        },
        {
          key: "reportos",
          name: "Reports",
        },
        {
          key: "fbpEligibilityConfig",
          name: "FBP Eligibility Config"
        },
        // {
        //   key: "settings",
        //   name: "Settings",
        // },
        // {
        //   key: "add_new_joinee",
        //   name: "Add New Joinee",
        // },
        // {
        //   key: "add_exiting_employees",
        //   name: "Add Exiting Employees",
        // },
        // {
        //   key: "update_lops_rlops",
        //   name: "Update LOPs/RLOPs",
        // },
        // {
        //   key: "tds_overrides",
        //   name: "TDS Overrides",
        // },
        // {
        //   key: "manage_team_roles",
        //   name: "Manage Team Roles",
        // },
        // {
        //   key: "variable_earnings_deductions",
        //   name: "Variable Earnings & Deductions",
        // },
        {
          key: "approve_and_reject_it_proof",
          name: "Approve and reject IT Proof",
        },
        {
          key: "process_fnf",
          name: "Process FnF",
        },
        {
          key: "fbp_settings",
          name: "FBP Settings",
        },
      ],
      tagsArray: [],
      tagsOrgsArray: [],
      tagsEntityArray: [],
      favOrgs: [],
      searchOrg: "",
      organisationList: [],
      tempOrgArray: [],
      orgName: null,
      entityList: [],
      tempEntityList: [],
      entity: null,
      rolePermissions: [],
    };
  },
  mounted() {
    this.getAllOrgs();
    this.fetchAll();
  },
  computed: {
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    //  onboardingOrgId: state => state.onboard.organization.id,
    }),
    permissionoption() {
      if (this.formData.role == "ADMIN")
        this.rolePermissions = [
          'All Permission','Create Legal Entity','Organisation List', 'Legal Entity List', 'Legal Entity Info', 'Location',
          'Statutory Settings', 'Departments', 'Cost Centers', 'Designation', 'Levels', 'Salary Grade', 'Emp Cat and Sub-Cat',
          'Salary Bands', 'Misc', 'Payroll Preferences', 'Paygroup', 'Add Employee', 'Legacy Data', 'Payroll Dashboards', 
          'IT Declarations', 'IT Proof Submission', 'IT Proof Approval', 'Assign fixed & Non CTC component', 'Exit employee Details',
          'Delete payroll data', 'Form 16', 'Hold/Release salary', 'Increment Arrear Override', 'Leaves Attendance',
          'Legacy salary', 'Lop/Rlop', 'Revise salary', 'Statutory Bonus', 'Statutory Deduction', 'Manage Roles',
          'Download/Upload Master Template', 'ESS Management', 'Payslips & IT Sheets', 'Update Form 24Q acknowledgement',
          'Company', 'Reports','Process FnF','FBP Eligibility Config',
          'FBP Settings'
          //'Add User', 'Add User Permission', 'Create Legal Entity', 'Create Organisation'
        ];
      if (this.formData.role == "TEAMLEADER")
        this.rolePermissions = [
          'All Permission','Organisation List', 'Legal Entity List', 'Legal Entity Info', 'Location',
          'Statutory Settings', 'Departments', 'Cost Centers', 'Designation', 'Levels', 'Salary Grade', 'Emp Cat and Sub-Cat',
          'Salary Bands', 'Misc', 'Payroll Preferences', 'Paygroup', 'Add Employee', 'Legacy Data', 'Payroll Dashboards', 
          'IT Declarations', 'IT Proof Submission', 'IT Proof Approval', 'Assign fixed & Non CTC component', 'Exit employee Details',
          'Delete payroll data', 'Form 16', 'Hold/Release salary', 'Increment Arrear Override', 'Leaves Attendance',
          'Legacy salary', 'Lop/Rlop', 'Revise salary', 'Statutory Bonus', 'Statutory Deduction', 'Manage Roles',
          'Download/Upload Master Template', 'ESS Management', 'Payslips & IT Sheets', 'Update Form 24Q acknowledgement',
          'Company', 'Reports','Process FnF' ,'FBP Eligibility Config',
          'FBP Settings' 
          //'Settings', 'Add New Joinee', 'Add Exiting Employees', 'Update LOPs/RLOPs', 'TDS Overrides',
          //'Manage Team Roles', 'Variable Earnings & Deductions'
       ];
      if (this.formData.role == "ANCHOR")
        this.rolePermissions = [
          'All Permission','Organisation List', 'Legal Entity List', 'Add Employee', 'Legacy Data', 'Payroll Dashboards', 
          'IT Declarations', 'IT Proof Submission', 'IT Proof Approval', 'Assign fixed & Non CTC component', 'Exit employee Details',
          'Delete payroll data', 'Form 16', 'Hold/Release salary', 'Increment Arrear Override', 'Leaves Attendance',
          'Legacy salary', 'Lop/Rlop', 'Revise salary', 'Statutory Bonus', 'Statutory Deduction', 'Manage Roles',
          'Download/Upload Master Template', 'ESS Management', 'Payslips & IT Sheets', 'Update Form 24Q acknowledgement',
          'Company', 'Reports','Process FnF' 
          //'Settings', 'Add New Joinee', 'Add Exiting Employees', 'Update LOPs/RLOPs', 'TDS Overrides',
          //'Manage Team Roles', 'Variable Earnings & Deductions'
        ];
      if (this.formData.role == "AUDITOR")
        this.rolePermissions = [
          'All Permission','Organisation List', 'Legal Entity List', 'Approve and reject IT Proof'
        ];
        return this.rolePermissions
    },
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
  },
  methods: {
    ...mapActions({
      //signupuser: "auth/createUser",
      //getSearchOrgs: "onboard/organization/searchFavouriteOrg",
      getFavouriteOrgs: "onboard/organization/fetchFavouriteOrg",
      act_fetchle: "onboard/legal_entities/fetchAll",
      savepermission:"auth/editRolePermission"
    }),

    async fetchAll() {
      let Obj = this.userRole;
      this.formData.role = Obj.userRole;
      let keyValue = Object.keys(Obj.permissions);
      this.permissionList.forEach(ele => {
        keyValue.forEach(el => {
          if(el == ele.key) {
            Object.assign(this.formData.permissions, { [ele.key]: Obj.permissions[el] })
            this.tagsArray.push({ key: ele.key, name: ele.name})
          }
        })
      })

      let orgKeyValue = Object.keys(Obj.organisations);
      let res = await this.getFavouriteOrgs();
        
      this.tempOrgArray = res.data.payload.data;
      this.tempOrgArray.forEach( ele => {
        orgKeyValue.forEach(el => {
          if(el == ele.id) {
            Object.assign(this.formData.organisations, { [el]: { legal_entity: Obj.organisations[el].legal_entity } });
            this.tagsOrgsArray.push({ 
              id: ele.id, 
              name: ele.name, 
              entityList: this.entityList, 
              tempEntityList: this.tempEntityList,
              tagsEntityArray: Obj.organisations[el].legal_entity,
              entity: undefined,
            });
          }
        })
      })
    },

    backToWelcomeScreen() {
      this.$emit('back');
    },

    async performAction() {
      try {
        this.formData.user_id = this.userRole.id;
        //console.log("User Id", this.formData.user_id);
        let res = await this.savepermission(this.formData);
        //console.log("Create User Account", res);

        if (res.status) {
          this.showSuccessMsg = true;
        } else {
          this.errmsg = res ? res : "Something went wrong from server side.";
          this.toast = true;
        }

        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    gotoSignIn() {
      this.$router.push({ path: "/signin" });
    },

    addTags() {
      if(this.screenpermission === "All Permission") {
        this.permissionList.filter(i => i.name !== "All Permission").forEach(element => {
          const isValid = this.rolePermissions.find(i => i === element.name)
          const isPresnet = this.tagsArray.find(i => i.name === element.name);
          if (isValid && !isPresnet) {
            Object.assign(this.formData.permissions, { [element.key]: true })
            this.tagsArray.push({ key: element.key, name: element.name })
            this.screenpermission = undefined
          }
        });        
      } else {
        let permission = null
        this.permissionList.filter(i => i.name !== "All Permission").forEach(element => {
            if(element.name === this.screenpermission) {
              permission = element
            }
        })
        const isPresnet = this.tagsArray.find(i => i.name === this.screenpermission);
        if (permission && !isPresnet) {
          Object.assign(this.formData.permissions, { [permission.key]: true })
          this.tagsArray.push({ key: permission.key, name: this.screenpermission })
          this.screenpermission = undefined
        }
      }
    },

    addOrgTags() {
      let orgnisation = this.tempOrgArray.find(i => i.name === this.orgName);
      const isPresnet = this.tagsOrgsArray.find(i => i.name === this.orgName);
      if (orgnisation && !isPresnet) {
        Object.assign(this.formData.organisations, { [orgnisation['id']]: { legal_entity: [] } });
        this.tagsOrgsArray.push({ 
          id: orgnisation['id'], 
          name: this.orgName, 
          entityList: this.entityList, 
          tempEntityList: this.tempEntityList,
          tagsEntityArray: [],
          entity: undefined,
          });
        this.orgName = undefined;
        this.entityList = [];
        this.tempEntityList = [];
      }
    },

    addEntityTags(data) {
      let entity = data.tempEntityList.find(i => i.legalName === data.entity);
      const isPresent = data.tagsEntityArray.find(i => i.name === data.entity);
      if (entity && !isPresent) {
        this.formData.organisations[data.id]["legal_entity"].push({
          id: entity.id,
          name: entity.legalName,
          to_date: new Date().toISOString().slice(0, 10),
          from_date: new Date().toISOString().slice(0, 10),
        })
        data.tagsEntityArray.push({ 
          id: entity.id, 
          name: data.entity,
          to_date: new Date().toISOString().slice(0, 10),
          from_date: new Date().toISOString().slice(0, 10),
          });
        data.entity = undefined;
      }
    },

    removeTag (key) {
      let index = this.tagsArray.findIndex(i => i.key === key)
      if (index > -1) {
        this.tagsArray.splice(index, 1)
        delete this.formData.permissions[key]
        //console.log(this.tagsArray, this.formData)
      }
    },

    removeOrgTags(id) {
      let index = this.tagsOrgsArray.findIndex(i => i.id === id)
      if (index > -1) {
        this.tagsOrgsArray.splice(index, 1)
        delete this.formData.organisations[id]
        //console.log(this.tagsOrgsArray, this.formData)
      }
    },

    removeEntityTags(data, index) {
      this.formData.organisations[data.id]["legal_entity"].splice(index, 1);
      data["tagsEntityArray"].splice(index, 1)
      //console.log("Remove entity:", this.formData, data)
    },

    dateChanged(data, index, val, type) {
      if (type === 'From Date') {
        this.formData.organisations[data.id]["legal_entity"][index]["from_date"] = val;
        data[tagsEntityArray][index]["from_date"] = val
      } else {
        this.formData.organisations[data.id]["legal_entity"][index]["to_date"] = val;
        data[tagsEntityArray][index]["to_date"] = val
      }
      //console.log("Date:", this.formData)
    },

    /** Function to fetch all organisations */
    async getAllOrgs() {
      try {
        let res = await this.getFavouriteOrgs();
        res.data.payload.data.forEach(element => {
          this.organisationList.push(element.name);
        });
        this.tempOrgArray = res.data.payload.data;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to fetch the List of LEs for an Organisation */
    async getLeData(org) {
      try {
        this.orgName = org;
        let orgId = this.tempOrgArray.find(i => i.name === org).id;
        if (orgId) {
          let res = await this.act_fetchle(orgId);
          res.data.payload.data.forEach(element => {
          this.entityList.push(element.legalName);
        });
        this.tempEntityList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.signup-form {
  width: 350px;
  background-color: #fff;
  border-radius: 4px;
  // box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
  // padding: 16px 40px 25px 40px;
}
.label {
  height: 15px;
  margin-bottom: 9px;
  margin-top: 25px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.first-label {
  height: 15px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.signup-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 4px;
  padding: 15px 9px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}
.signup-btn {
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}
.signin-text {
  display: flex;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
}
.signin-text div {
  height: 15px;
  font-family: Montserrat;
  font-size: 14px;
  color: #868686;
}
.signin-text a {
  text-decoration: none;
}
.phone-number {
  position: relative;
}
.phone-number span {
  position: absolute;
  right: 0;
  color: #0e0e0e;
  opacity: 0.59;
}
@media only screen and (max-width: 600px) {
  .signin-form {
    padding: 16px 20px 25px 20px;
  }
}
.errorMessage {
  color: #e01717;
  padding-top: 5px;
}
.selectedComp {
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
}
.rect {
  padding: 10px 20px 10px 20px;
  margin: 2px;
  border-radius: 21px;
  background-color: #5d409f;
  color: #fff;
  text-align: center;
  display: inline-block;
  img {
    padding-left: 10px;
    top: 4px;
    position: relative;
  }
}
span.tag-title {
  position: relative;
  top: -8px;
  cursor: none;
}
.addTagBtn {
  top: 54px;
  position: relative;
}
.labelText {
  height: 15px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}
.legalBtn {
  top: 20px;
  position: relative;
}
</style>
